/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  EIP4337Fallback,
  EIP4337FallbackInterface,
} from "../../../../contracts/samples/gnosis/EIP4337Fallback";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_eip4337manager",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "eip4337manager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "",
        type: "uint8",
      },
    ],
    name: "executeAndRevert",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes",
      },
    ],
    name: "isValidSignature",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "tokensReceived",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "",
        type: "tuple",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "validateUserOp",
    outputs: [
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x60a060405234801561001057600080fd5b506040516111ec3803806111ec83398101604081905261002f91610040565b6001600160a01b0316608052610070565b60006020828403121561005257600080fd5b81516001600160a01b038116811461006957600080fd5b9392505050565b60805161115a6100926000396000818161019b0152610616015261115a6000f3fe608060405234801561001057600080fd5b50600436106100d35760003560e01c8063940d3c6011610081578063d087d2881161005b578063d087d2881461029a578063f23a6e61146102a2578063ffa1ad74146102db57600080fd5b8063940d3c6014610203578063a3f4df7e14610216578063bc197c811461025f57600080fd5b80631626ba7e116100b25780631626ba7e146101835780632bcadc24146101965780633a871cdd146101e257600080fd5b806223de29146100d857806301ffc9a7146100f2578063150b7a021461011a575b600080fd5b6100f06100e6366004610a1e565b5050505050505050565b005b610105610100366004610ac9565b610317565b60405190151581526020015b60405180910390f35b610152610128366004610b0b565b7f150b7a020000000000000000000000000000000000000000000000000000000095945050505050565b6040517fffffffff000000000000000000000000000000000000000000000000000000009091168152602001610111565b610152610191366004610c94565b6103fc565b6101bd7f000000000000000000000000000000000000000000000000000000000000000081565b60405173ffffffffffffffffffffffffffffffffffffffff9091168152602001610111565b6101f56101f0366004610cdb565b610554565b604051908152602001610111565b6100f0610211366004610d2f565b61057e565b6102526040518060400160405280601881526020017f44656661756c742043616c6c6261636b2048616e646c6572000000000000000081525081565b6040516101119190610dcd565b61015261026d366004610e63565b7fbc197c810000000000000000000000000000000000000000000000000000000098975050505050505050565b6101f561058d565b6101526102b0366004610efd565b7ff23a6e61000000000000000000000000000000000000000000000000000000009695505050505050565b6102526040518060400160405280600581526020017f312e302e3000000000000000000000000000000000000000000000000000000081525081565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f4e2312e00000000000000000000000000000000000000000000000000000000014806103aa57507fffffffff0000000000000000000000000000000000000000000000000000000082167f150b7a0200000000000000000000000000000000000000000000000000000000145b806103f657507fffffffff0000000000000000000000000000000000000000000000000000000082167f01ffc9a700000000000000000000000000000000000000000000000000000000145b92915050565b600080610456846040517f19457468657265756d205369676e6564204d6573736167653a0a3332000000006020820152603c8101829052600090605c01604051602081830303815290604052805190602001209050919050565b9050600061046482856105b4565b6040517f2f54bf6e00000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff8216600482015290915033908190632f54bf6e90602401602060405180830381865afa1580156104d3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906104f79190610f85565b1561052857507f1626ba7e0000000000000000000000000000000000000000000000000000000092506103f6915050565b507fffffffff0000000000000000000000000000000000000000000000000000000092506103f6915050565b60008061055f6105d8565b9050808060200190518101906105759190610fa0565b95945050505050565b6105866105d8565b5050505050565b6000806105986105d8565b9050808060200190518101906105ae9190610fa0565b91505090565b60008060006105c385856106c4565b915091506105d081610709565b509392505050565b6040517f5229073f000000000000000000000000000000000000000000000000000000008152606090339060009081908390635229073f90610647907f000000000000000000000000000000000000000000000000000000000000000090859081903690600190600401610fe8565b6000604051808303816000875af1158015610666573d6000803e3d6000fd5b505050506040513d6000823e601f3d9081017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01682016040526106ac919081019061109a565b91509150816106bd57805160208201fd5b9392505050565b60008082516041036106fa5760208301516040840151606085015160001a6106ee878285856108c4565b94509450505050610702565b506000905060025b9250929050565b600081600481111561071d5761071d610fb9565b036107255750565b600181600481111561073957610739610fb9565b036107a5576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601860248201527f45434453413a20696e76616c6964207369676e6174757265000000000000000060448201526064015b60405180910390fd5b60028160048111156107b9576107b9610fb9565b03610820576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601f60248201527f45434453413a20696e76616c6964207369676e6174757265206c656e67746800604482015260640161079c565b600381600481111561083457610834610fb9565b036108c1576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202773272076616c60448201527f7565000000000000000000000000000000000000000000000000000000000000606482015260840161079c565b50565b6000807f7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a08311156108fb57506000905060036109aa565b6040805160008082526020820180845289905260ff881692820192909252606081018690526080810185905260019060a0016020604051602081039080840390855afa15801561094f573d6000803e3d6000fd5b50506040517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0015191505073ffffffffffffffffffffffffffffffffffffffff81166109a3576000600192509250506109aa565b9150600090505b94509492505050565b803573ffffffffffffffffffffffffffffffffffffffff811681146109d757600080fd5b919050565b60008083601f8401126109ee57600080fd5b50813567ffffffffffffffff811115610a0657600080fd5b60208301915083602082850101111561070257600080fd5b60008060008060008060008060c0898b031215610a3a57600080fd5b610a43896109b3565b9750610a5160208a016109b3565b9650610a5f60408a016109b3565b955060608901359450608089013567ffffffffffffffff80821115610a8357600080fd5b610a8f8c838d016109dc565b909650945060a08b0135915080821115610aa857600080fd5b50610ab58b828c016109dc565b999c989b5096995094979396929594505050565b600060208284031215610adb57600080fd5b81357fffffffff00000000000000000000000000000000000000000000000000000000811681146106bd57600080fd5b600080600080600060808688031215610b2357600080fd5b610b2c866109b3565b9450610b3a602087016109b3565b935060408601359250606086013567ffffffffffffffff811115610b5d57600080fd5b610b69888289016109dc565b969995985093965092949392505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe016810167ffffffffffffffff81118282101715610bf057610bf0610b7a565b604052919050565b600067ffffffffffffffff821115610c1257610c12610b7a565b50601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01660200190565b600082601f830112610c4f57600080fd5b8135610c62610c5d82610bf8565b610ba9565b818152846020838601011115610c7757600080fd5b816020850160208301376000918101602001919091529392505050565b60008060408385031215610ca757600080fd5b82359150602083013567ffffffffffffffff811115610cc557600080fd5b610cd185828601610c3e565b9150509250929050565b600080600060608486031215610cf057600080fd5b833567ffffffffffffffff811115610d0757600080fd5b84016101608187031215610d1a57600080fd5b95602085013595506040909401359392505050565b60008060008060808587031215610d4557600080fd5b610d4e856109b3565b935060208501359250604085013567ffffffffffffffff811115610d7157600080fd5b610d7d87828801610c3e565b925050606085013560028110610d9257600080fd5b939692955090935050565b60005b83811015610db8578181015183820152602001610da0565b83811115610dc7576000848401525b50505050565b6020815260008251806020840152610dec816040850160208701610d9d565b601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0169190910160400192915050565b60008083601f840112610e3057600080fd5b50813567ffffffffffffffff811115610e4857600080fd5b6020830191508360208260051b850101111561070257600080fd5b60008060008060008060008060a0898b031215610e7f57600080fd5b610e88896109b3565b9750610e9660208a016109b3565b9650604089013567ffffffffffffffff80821115610eb357600080fd5b610ebf8c838d01610e1e565b909850965060608b0135915080821115610ed857600080fd5b610ee48c838d01610e1e565b909650945060808b0135915080821115610aa857600080fd5b60008060008060008060a08789031215610f1657600080fd5b610f1f876109b3565b9550610f2d602088016109b3565b94506040870135935060608701359250608087013567ffffffffffffffff811115610f5757600080fd5b610f6389828a016109dc565b979a9699509497509295939492505050565b805180151581146109d757600080fd5b600060208284031215610f9757600080fd5b6106bd82610f75565b600060208284031215610fb257600080fd5b5051919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b73ffffffffffffffffffffffffffffffffffffffff8616815284602082015260806040820152826080820152828460a0830137600060a08483010152600060a07fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0601f86011683010190506002831061108a577f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b8260608301529695505050505050565b600080604083850312156110ad57600080fd5b6110b683610f75565b9150602083015167ffffffffffffffff8111156110d257600080fd5b8301601f810185136110e357600080fd5b80516110f1610c5d82610bf8565b81815286602083850101111561110657600080fd5b611117826020830160208601610d9d565b809350505050925092905056fea26469706673582212201305a2279740f467f2420436806608d8cc2e493abddc28a5205c5752e2dd2aa664736f6c634300080f0033";

type EIP4337FallbackConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: EIP4337FallbackConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class EIP4337Fallback__factory extends ContractFactory {
  constructor(...args: EIP4337FallbackConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _eip4337manager: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<EIP4337Fallback> {
    return super.deploy(
      _eip4337manager,
      overrides || {}
    ) as Promise<EIP4337Fallback>;
  }
  override getDeployTransaction(
    _eip4337manager: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_eip4337manager, overrides || {});
  }
  override attach(address: string): EIP4337Fallback {
    return super.attach(address) as EIP4337Fallback;
  }
  override connect(signer: Signer): EIP4337Fallback__factory {
    return super.connect(signer) as EIP4337Fallback__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EIP4337FallbackInterface {
    return new utils.Interface(_abi) as EIP4337FallbackInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): EIP4337Fallback {
    return new Contract(address, _abi, signerOrProvider) as EIP4337Fallback;
  }
}
